import { Box, BoxProps, Text } from '@chakra-ui/react'
import { appVersionLabel } from '@/shared/config/appVersion'

/**
 * The build stamp in the sidebar's bottom-left corner. Support asks "what are
 * you running?" before anything else, and staging and production regularly run
 * different builds — the packaged date is what tells them apart.
 */
export default function AppVersion(props: BoxProps) {
    const label = appVersionLabel()
    if (!label) return null

    return (
        <Box px="8" py="4" {...props}>
            <Text fontSize="xs" color="gray.400" data-testid="app-version">
                {label}
            </Text>
        </Box>
    )
}
